import { render, staticRenderFns } from "./merchant-order-edit.vue?vue&type=template&id=4e53fe15&scoped=true&"
import script from "./merchant-order-edit.vue?vue&type=script&lang=js&"
export * from "./merchant-order-edit.vue?vue&type=script&lang=js&"
import style0 from "./merchant-order-edit.vue?vue&type=style&index=0&id=4e53fe15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e53fe15",
  null
  
)

export default component.exports